import { forwardRef } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import { color, ColorProps } from "styled-system";

import Button from "../Button/Button";
import { ButtonProps } from "../Button/button.type";

import { ToggleOptionProps } from "./toggle.type";

const StyledToggleOption = styled(Button)<ButtonProps & ColorProps>`
	position: relative;
	height: auto;
	min-height: 35px;
	min-width: 35px;
	background-color: transparent;
	border: none;
	line-height: 1.7;
	transition: color 300ms ease-in-out;

	&:not([disabled]):hover,
	&:not([disabled]):focus {
		background-color: transparent;
	}

	&:not(:first-of-type)::before {
		content: "";
		display: block;
		position: absolute;
		height: 16px;
		width: 2px;
		background-color: #fff;
		left: -1px;
		opacity: 1;
		transition: opacity 300ms ease-in-out;
	}

	&.active,
	&.active + button {
		&::before {
			opacity: 0;
		}
	}
	${css({
		margin: 0,
		paddingX: 4,
		paddingY: 1,
		color: "toggle-inactive-option-color",
	})}
	${color}
`;

const ToggleOption = forwardRef<HTMLButtonElement, ToggleOptionProps>(
	(
		{
			children,
			className,
			color = "toggle-inactive-option-color",
			disabled,
			onClick = () => {},
		},
		ref
	) => {
		return (
			<StyledToggleOption
				ref={ref}
				className={className}
				onClick={onClick}
				disabled={disabled}
				color={color as string}
			>
				{children}
			</StyledToggleOption>
		);
	}
);

export default ToggleOption;
